import React from "react";
import styled from "@emotion/styled";

const BoardWrapper = styled.div`
  position: relative;
  padding-top: 100%;
  width: 100%;
  background: #fff;
  border: 1px solid #9a9a9a;
`;

const Board = ({ children }) => {
  return <BoardWrapper>{children}</BoardWrapper>;
};

export default Board;
